/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var errorTemplate = require('../../templates').errorTemplate;
var rootScope = require('./root-scope.service');

var loading = require('./loading.service');
var Messages = {
    german:
        'Leider konnten wir Ihre Zahlungsanfrage nicht fortführen. Vielleicht wurde Sie bereits ausgelöst oder ist abgelaufen. Sie können den Zahlungs-Checkout nochmals starten.',
    defaultLanguage:
        'Unfortunately we were unable to continue with your payment request. Maybe it was submitted already or timed out. You could start the payment checkout again.',
};
module.exports = function (err) {
    var language = navigator.language || navigator.browserLanguage || navigator.userLanguage;
    // just German check for now
    var isGerman = language.toLowerCase().indexOf('de') == 0;
    var message = isGerman ? Messages.german : Messages.defaultLanguage;
    rootScope.getListContainer().html(errorTemplate(message, rootScope.getTemplateName()));
    rootScope.getSubmitButton().hide();
    loading.hideFullPageLoading();
    throw new Error('A server error happening in handle server Error: ' + JSON.stringify(err));
};
